import React from 'react';

// eslint-disable-next-line max-len
const CAMPFIRE = '/themes/theme/campfire/logo.png';
const CAMPFIRE_DARK_LOGO = '/themes/theme/campfire/logo.png';

const CampfireTheme = {
  headerLogo: {
    src: CAMPFIRE,
    alt: 'Campfire Logo',
    size: 40,
  },
  darkLogo: {
    src: CAMPFIRE_DARK_LOGO,
    alt: 'Campfire Logo',
    size: 40,
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '4px solid #FBBD4B',
    height: 80,
  },
  title: 'Campfire',
  isLightOnDark: false,
  organisationId: '69f06ccc-17de-495a-87fb-fd13afeaa52e',
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <br /><br />
      <img
        height="60"
        src={CAMPFIRE} alt="Campfire Logo"
      />
      <br /><br />
    </div>
  ),
  shareSite: 'https://share.campfire.co.uk',
};

export default CampfireTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/campfire.js
 **/